import { useState } from "react";
import {
  Drawer,
  Box,
  IconButton,
  List,
  ListItem,
  ListItemText,
  Typography,
  Button,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import Logo from "../img/headrlogo.png"
import { Link } from "react-router-dom";
import styleCss from "../Style/style";
import HeadrIcon1 from "../img/headericon1.png";
import HeadrIcon2 from "../img/headericon2.png";
import HeadrIcon3 from "../img/headericon3.png";
import HeadrIcon4 from "../img/headericon4.png";
import HeadrIcon5 from "../img/headericon5.png";

const LeftMenuDrawer = () => {
  const [open, setOpen] = useState(false);

  const toggleDrawer = (isOpen) => (event) => {
    if (event.type === "keydown" && (event.key === "Tab" || event.key === "Shift")) {
      return;
    }
    setOpen(isOpen);
  };

  return (
    <Box>
      <IconButton onClick={toggleDrawer(true)} sx={{ color: "#000" }}>
        <MenuIcon />
      </IconButton>
      <Drawer anchor="left" open={open} onClose={toggleDrawer(false)}>
        <Box sx={{ width: 250, p: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between" }}>
            <img src={Logo} alt="" style={{ width: '100px' }} />
            <IconButton onClick={toggleDrawer(false)}>
              <CloseIcon />
            </IconButton>
          </Box>

          {/* Menu List */}
          <List>
            <ListItem button sx={{ paddingLeft: '0px' }}>
              <Link to="/" style={styleCss.HeaderMenustyle}>
                <Typography>
                  <img src={HeadrIcon1} alt="" style={styleCss.IconAlignstyle} />
                  My Bookings
                </Typography>
              </Link>
            </ListItem>
            <ListItem button sx={{ paddingLeft: '0px' }}>
              <Link to="/" style={styleCss.HeaderMenustyle}>
                <Typography>
                  <img src={HeadrIcon2} alt="" style={styleCss.IconAlignstyle} />
                  Supports
                </Typography>
              </Link>
            </ListItem>
            <ListItem button sx={{ paddingLeft: '0px' }}>
              <Link to="/" style={styleCss.HeaderMenustyle}>
                <Typography>
                  <img src={HeadrIcon3} alt="" style={styleCss.IconAlignstyle} />
                  Help & FAQ
                </Typography>
              </Link>
            </ListItem>
            <ListItem button sx={{ paddingLeft: '0px' }}>
              <Link to="/" style={styleCss.HeaderMenustyle}>
                <Typography>
                  <img src={HeadrIcon4} alt="" style={styleCss.IconAlignstyle} />
                  Track Bus
                </Typography>
              </Link>
            </ListItem>
            <ListItem button sx={{ paddingLeft: '0px' }}>
              <Button variant="contained" sx={{
                borderRadius: '6px',
                boxShadow: '0 4px 100px 0 rgba(0, 0, 0, 0.08)',
                backgroundColor: '#ff5714',
                fontFamily: 'Segoe UI',
                fontSize: '15px',
                fontWeight: 'bold',
                textAlign: 'left',
                color: '#fff',
                textTransform: 'capitalize',
                width: '100%',
              }}>Login</Button>
            </ListItem>
          </List>
        </Box>
      </Drawer>
    </Box>
  );
};

export default LeftMenuDrawer;
